<template>
    <section
        v-editable="blok"
        class="recent-articles"
    >
        <KSectionHeader
            class="recent-articles__header"
            :eyebrow="blok.eyebrow"
            :text="blok.text"
            :align="blok.align || 'start'"
        >
            <template
                v-if="title"
                #title
            >
                <span v-html="title" />
            </template>
            <template
                v-if="blok.action_label && (blok.action_link?.url || blok.action_link?.email || blok.action_link?.cached_url || blok.action_link?.anchor)"
                #actions
            >
                <StoryblokSectionHeaderAction
                    :label="blok.action_label"
                    :link="blok.action_link"
                    placement="recent-articles"
                />
            </template>
        </KSectionHeader>

        <div class="recent-articles__items">
            <recent-article
                v-for="item in articles"
                :key="item._uid"
                :item="item"
            />
        </div>
    </section>
</template>

<script setup>
import { KSectionHeader } from '@vemedia/karibu'
import renderHighlightedText from '~/helpers/renderHighlightedText'

const { blok } = defineProps(['blok'])

const title = computed(() => renderHighlightedText(blok.title))

// The key must carry the query: a static key is shared across client-side navigations, so
// moving from one hub to another rendered the previous hub's list.
const { data: articles } = await useAsyncData(
    `recent-articles-${blok.by_slug}-${blok.per_page}`,
    () => $fetch(`/api/recent-articles?by_slug=${blok.by_slug}&per_page=${blok.per_page}`),
)
</script>

<style lang="scss">
@use 'recent-articles';
</style>
